module.exports = __webpack_public_path__ + "e0e3b997d9ec22b24c77e511c333d42b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/pigmentation/pigmentation-2b.jpg
 ** module id = 440
 ** module chunks = 0
 **/